// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2yRiJ","fileDisabled":"File_fileDisabled__1Aw-j"};